import { useQuery } from "urql";

import { GetTenantsDocument, OrderBy } from "../../../graphql/generated.ts";

interface Props {
  pause?: boolean;
}

export function useTenantOptions({ pause }: Props) {
  const variables = {
    orderBy: { name: OrderBy.Asc },
  };
  return useQuery({
    query: GetTenantsDocument,
    variables,
    pause,
  });
}
